// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RO6BJCwm_qKQvbOfoVIQ {
  position: fixed;
  inset: 0 0 0 0;
  z-index: var(--dry-popover-zindex);
  background-color: transparent;
}
.jDcs6HyHFJI8HJVflmrC {
  position: absolute;
  z-index: 1;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RO6BJCwm_qKQvbOfoVIQ`,
	"content": `jDcs6HyHFJI8HJVflmrC`
};
export default ___CSS_LOADER_EXPORT___;
